var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501:3338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.28981C15 0.410585 14.2899 -0.299561 13.4106 -0.299561H2.58937C1.71015 -0.299561 1 0.410585 1 1.28981V14.4106C1 15.2898 1.71015 16 2.58937 16H13.4106C14.2899 16 15 15.2898 15 14.4106V1.28981ZM2.14976 14.4106V1.28981C2.14976 1.04633 2.33913 0.850199 2.58261 0.850199H3.40097V14.8502H2.58261C2.33913 14.8502 2.14976 14.6541 2.14976 14.4106ZM13.8503 14.4106C13.8503 14.6541 13.6609 14.8502 13.4174 14.8502H4.55073V0.850199H13.4174C13.6609 0.850199 13.8503 1.04633 13.8503 1.28981V14.4106Z",
    fill: "#A4A6B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4976 3.04827C12.4976 2.73039 12.2406 2.47339 11.9227 2.47339H6.57972C6.26184 2.47339 6.00484 2.73039 6.00484 3.04827V10.3188C6.00484 10.6367 6.26184 10.8937 6.57972 10.8937H11.9227C12.2406 10.8937 12.4976 10.6367 12.4976 10.3188V3.04827ZM11.3817 9.71011H7.1546V3.62315H11.3817V9.71011Z",
    fill: "#A4A6B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9464 11.942H6.59324C6.27536 11.942 6.01836 12.199 6.01836 12.5169C6.01836 12.8348 6.27536 13.0918 6.59324 13.0918H11.9498C12.2676 13.0918 12.5246 12.8348 12.5246 12.5169C12.5246 12.199 12.2643 11.942 11.9464 11.942Z",
    fill: "#A4A6B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501:3338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsMenuIcon);
export default __webpack_public_path__ + "static/media/docs-menu-icon.d2db0b546aeaa6281e84e869bffbd6dc.svg";
export { ForwardRef as ReactComponent };